import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "16",
  viewBox: "0 0 10 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.5 13.5833V2.41663H8.5V13.5833H1.5ZM0 1.91663C0 1.36434 0.447715 0.916626 1 0.916626H9C9.55228 0.916626 10 1.36434 10 1.91663V14.0833C10 14.6356 9.55229 15.0833 9 15.0833H1C0.447716 15.0833 0 14.6356 0 14.0833V1.91663ZM6.66667 8.83329C7.1269 8.83329 7.5 8.4602 7.5 7.99996C7.5 7.53972 7.1269 7.16663 6.66667 7.16663C6.20643 7.16663 5.83333 7.53972 5.83333 7.99996C5.83333 8.4602 6.20643 8.83329 6.66667 8.83329Z",
      fill: "#FF5537"
    }, null, -1)
  ]))]))
}
export default { render: render }